import { Space, WithPopover } from '@procurify/ui'

import {
  AmountFraction,
  AmountFractionType,
} from '@webapp/components/AmountFraction'
import { APItemReceivedCellStyled } from './styles/APItemReceivedCellStyled'
import { useAPItemReceivedCell } from './useAPItemReceivedCell'
import { type ColumnTypeData } from '../../types/DataTable.types'

// Remove this when AP_10171_AP_INLINE_EDITS is removed
export const APItemReceivedCell = ({
  billItem,
}: ColumnTypeData['AP_ITEM_RECEIVED']) => {
  const { iconContent, popoverContent, hasException } =
    useAPItemReceivedCell(billItem)

  if (!billItem.isReceivedByCost && !billItem.isReceivedByQuantity) {
    return <>--</>
  }

  return (
    <WithPopover
      content={popoverContent}
      isDisabled={!popoverContent}
      placement='top'
      minWidth='384px'
    >
      <APItemReceivedCellStyled exception={hasException}>
        <Space direction='horizontal' size='xsmall' justify='center'>
          {iconContent}
          {billItem.isReceivedByCost && (
            <AmountFraction
              type={AmountFractionType.COST}
              amount={billItem.itemSummary.receivedCost}
              totalAmount={billItem.itemSummary.purchasedCost}
              currencyName={billItem.currencyName}
              size='small'
            />
          )}
          {billItem.isReceivedByQuantity && (
            <AmountFraction
              type={AmountFractionType.QUANTITY}
              amount={billItem.itemSummary.receivedQuantity}
              totalAmount={billItem.itemSummary.purchasedQuantity}
              size='small'
            />
          )}
        </Space>
      </APItemReceivedCellStyled>
    </WithPopover>
  )
}
